import React from 'react';
import Slider from './components/Slider'
import electionData from './data'
import './App.css'

function App() {
  return (
    <div className="App">
      <div className='container'>
        <div className='row '>
          <Slider electionData = {electionData} />
        </div>
        <footer>
          <p><a href='https://www.kaggle.com/datasets/tunguz/us-elections-dataset?resource=download' target='_blank'>data</a> | <small>made with react</small>
          </p>
        </footer>
      </div>
     
    </div>
  );
}

export default App;
